import * as angular from "angular";

export class AttendanceRequestsService {

  /* @ngInject */
  constructor(private $attendance, private AttendanceAPI) {
  }

  getClockInResources(params: {
    agentId: string;
    provider?: string;
    from?: number;
    to?: number;
    query?: string;
    scope?: string;
    cursor?: string;
    limit?: number;
    sort?: string;
  }) {
    const api = this.AttendanceAPI.actions.getResources;
    const queryParams: any = {};
    
    Object.keys(params).forEach(key => {
      if (key !== 'agentId' && params[key] !== undefined && params[key] !== null) {
        queryParams[key] = params[key];
      }
    });

    return this.$$call(api, queryParams, {}, {agentId: params.agentId});
  }

  clockIn(agentId: string, plannedResource?: { id: string; providerType: string }) {
    const api = this.AttendanceAPI.actions.clockIn;
    const body = plannedResource ? { plannedResource } : {};
    return this.$$call(api, {}, body, {agentId: agentId});
  }

  clockOut(agentId: string, plannedResource?: { id: string; providerType: string }) {
    const api = this.AttendanceAPI.actions.clockOut;
    const body = plannedResource ? { plannedResource } : {};
    return this.$$call(api, {}, body, {agentId: agentId});
  }

  startBreak(agentId: string, breakTypeId?: string) {
    const api = this.AttendanceAPI.actions.startBreak;
    const body = breakTypeId ? { breakTypeId } : {};
    return this.$$call(api, {}, body, {agentId: agentId});
  }

  private $$call(_apiCall, _params, _data, _options) {
    return this.$attendance().$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.timekeeping')
  .service('attendanceRequestsService', AttendanceRequestsService);
